import React from "react";

const Footer = props => {
  const { company = "ALT Plus X Co.,LTD." } = props;
  return (
    <div className="container-fluid">
      <hr />
      <div className="text-center title text-uppercase">
        <small>
          <span className="text-danger">Powered By {company}</span>
        </small>
      </div>
    </div>
  );
};

export default Footer;
